export default "__VITE_PUBLIC_ASSET__5dd728c9__"